import React from 'react';
import PropTypes from 'prop-types';
import {
  SectionLink,
  SectionLabel,
  SectionIconWrapper,
  ImagePath,
  SectionIconRightWrapper,
  SectionLinkButton
} from '../detailPageStyle';

const ClaimWrapper = props => {
  const {
    id,
    ariaLabel,
    onClick,
    iconSrc,
    linkLabel,
    iconRight,
    linkRef,
    href,
    showButtonAsLink
  } = props;
  if (showButtonAsLink) {
    return (
      <SectionLinkButton
        id={id}
        aria-label={ariaLabel}
        onClick={onClick}
        ref={linkRef}
        type="button"
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer'
        }}
      >
        <SectionIconWrapper>
          <ImagePath aria-hidden="true" alt="" src={iconSrc} />
        </SectionIconWrapper>
        <SectionLabel>{linkLabel}</SectionLabel>
        <SectionIconRightWrapper>
          <ImagePath aria-hidden="true" alt="" src={iconRight} />
        </SectionIconRightWrapper>
      </SectionLinkButton>
    );
  }

  return (
    <SectionLink
      href={href}
      id={id}
      aria-label={ariaLabel}
      onClick={onClick}
      rel="noopener noreferrer"
      ref={linkRef}
    >
      <SectionIconWrapper>
        <ImagePath aria-hidden="true" alt="" src={iconSrc} />
      </SectionIconWrapper>
      <SectionLabel>{linkLabel}</SectionLabel>
      <SectionIconRightWrapper>
        <ImagePath aria-hidden="true" alt="" src={iconRight} />
      </SectionIconRightWrapper>
    </SectionLink>
  );
};

export default ClaimWrapper;

ClaimWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  linkLabel: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired,
  iconRight: PropTypes.string,
  linkRef: PropTypes.object.isRequired,
  href: PropTypes.string,
  showButtonAsLink: PropTypes.bool
};
ClaimWrapper.defaultProps = {
  iconRight: '',
  href: '#',
  showButtonAsLink: false
};
